import React from "react";
import "@frameworks/shared-library/stylesheets/components/GenericDateSelector/GenericDateSelector.scss";
import GenericSelect from "@frameworks/shared-library/components/GenericSelect/GenericSelect";
var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
var GenericDateSelectorHeader = function (_a) {
    var date = _a.date, changeYear = _a.changeYear, changeMonth = _a.changeMonth, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled, monthRangeStart = _a.monthRangeStart, dropDownClassName = _a.dropDownClassName;
    var yearOptions = Array(100)
        .fill(0)
        .map(function (_, i) {
        var year = monthRangeStart + i;
        return { label: year, value: year };
    });
    return (React.createElement("div", { className: "primary-custom-calendar-header-container d-flex justify-content-between align-items-center" },
        !prevMonthButtonDisabled ? (React.createElement("span", { className: "input-group-text", onClick: decreaseMonth },
            React.createElement("i", { className: "edel-icon-arrow-left" }))) : (React.createElement("span", { className: "w-2" })),
        React.createElement("div", { className: "d-flex" },
            React.createElement("span", { className: "DMSans_16_500" }, months[date.getMonth()]),
            React.createElement(GenericSelect, { value: { label: date.getFullYear(), value: date.getFullYear() }, onChange: function (selected) {
                    if (selected) {
                        var selectedYear = selected.value;
                        changeYear(Number(selectedYear));
                    }
                }, showSelectOptionByDefault: false, classNamePrefix: dropDownClassName ? dropDownClassName : "", options: yearOptions, parentClassName: "no-border year-dropdown DMSans_16_500", isSearchable: false })),
        !nextMonthButtonDisabled ? (React.createElement("span", { className: "input-group-text", onClick: increaseMonth },
            React.createElement("i", { className: "edel-icon-arrow-right" }))) : (React.createElement("span", { className: "w-2" }))));
};
export default GenericDateSelectorHeader;
